import React from 'react';
import PortfoliosProgressItem from './PortfoliosProgressItem';
import {ReactComponent as moneyIcon} from '../../../assets/money.svg';
import {ReactComponent as rocketIcon} from '../../../assets/rocket.svg';
import {ReactComponent as stackIcon} from '../../../assets/stack.svg';
import {ReactComponent as swapIcon} from '../../../assets/swap.svg';
import {ReactComponent as usersIcon} from '../../../assets/users.svg';
import { Utilities } from '../../../utility/utils';
import { lighten, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../store/reducers/store';

const PortfoliosProgress: React.FC = () => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const summary = useAppSelector(state => state.dashboard.portfolioSummary);
    const toCoord = (coord: number[]): {x: number, y: number} => {
        return { x: coord[0], y: coord[1]};
    }
    const radius = 350;
    const circleRadius = radius + 25;
    // Utilities.f_svg_rotate_coord([0, 370], 0).map((value))
    if (summary === undefined){
        return <></>;
    }
    return <>
        <path d={Utilities.f_svg_ellipse_arc([0, 0], [circleRadius, circleRadius], [0, 3*Math.PI/4], Math.PI/8)} stroke={lighten(theme.palette.primary.dark,0.675)} strokeWidth="5" strokeDasharray={"900"} strokeDashoffset={"900"} className='drawable-illustration'/>
        <PortfoliosProgressItem coord={toCoord(Utilities.f_svg_rotate_coord([0, radius], 3*Math.PI/8))} icon={rocketIcon} title={t('DashboardPortfolioProgressTitle1')} value={`€ ${summary.totalRaised?.toLocaleString(i18n.language)}`} align='end' animationDelay="1.2s" />
        <PortfoliosProgressItem coord={toCoord(Utilities.f_svg_rotate_coord([0, radius], 3*Math.PI/16))} icon={stackIcon} title={t('DashboardPortfolioProgressTitle2')} value={`€ ${summary.totalRemaining?.toLocaleString(i18n.language)}`} align='end' animationDelay="0.9s" />
        <PortfoliosProgressItem coord={{x: 0, y: radius}} icon={moneyIcon} title={t('DashboardPortfolioProgressTitle3')} value={`${summary.activePortfolioCount?.toLocaleString(i18n.language)}`} align='center' animationDelay="0.6s" />
        <PortfoliosProgressItem coord={toCoord(Utilities.f_svg_rotate_coord([0, radius], -3*Math.PI/16))} icon={swapIcon} title={t('DashboardPortfolioProgressTitle4')} value={`${summary.aggregatedTVPI?.toLocaleString(i18n.language)}`} align='start' animationDelay="0.3s" />
        <PortfoliosProgressItem coord={toCoord(Utilities.f_svg_rotate_coord([0, radius], -3*Math.PI/8))} icon={usersIcon} title={t('DashboardPortfolioProgressTitle5')} value={`${summary.totalInverstors?.toLocaleString(i18n.language)}`} align='start' />
    </>;
}

export default PortfoliosProgress;